import axios from "axios"

/**
 * Le programme du stage acheté, lu et adapté par la famille depuis l'espace
 * parent — sur le jeton de l'élève, comme tout l'espace parent.
 */
function getStageProgram() {
    return axios.get("/api/v1/stage-program")
}

/** `instructions` vide : retour au programme acheté. */
function adaptStageProgram({}, data) {
    return axios.post("/api/v1/stage-program/adapt", data)
}

export const stageProgramService = {
    getStageProgram,
    adaptStageProgram,
}
